$(document).ready(function(){
    $('.js-videoSlider').slick({
        dots: false,
        vertical: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        verticalSwiping: true,
        infinite: true,
        arrows: true,
        prevArrow:"<button type='button' class='slick-prev slick-upArrow'><i class='icon--prev' aria-hidden='true'></i></button>",
        nextArrow:"<button type='button' class='slick-next slick-downArrow'><i class='icon--next' aria-hidden='true'></i></button>"
    });
    
    $("[data-videourl]").on("click", function () {
        var el = $(this);
        var url = el.data("videourl");
        $('[data-target]').attr("src", url);
        // $(this).closest('.videoSlider').find('[data-youtube-gallerypreview]').attr("src", url);
    });
    
    $("[data-videourl]").eq(0).trigger("click");
});
